import 'reflect-metadata';
import { LogLevel } from './ILogger.js';
// Constants specific to the logging module
export const RESOURCES = {
    // DOM can cause a log to be written via: window.dispatchEvent(new CustomEvent('qbo-log', { detail: { logLevel: 3, message: '...'}})
    WRITE_LOG: "qbo-log",
    // DOM Can listen for a log to be written via: window.addEventListener('qbo-log-write', (event) => { ... })
    WRITING_LOG: "qbo-log-write"
};
export { services } from '@quandis/qbo4.ui';
export * from './ILogEntry.js';
export * from './ILogger.js';
export * from './ILoggerService.js';
export * from './ILogReader.js';
export * from './ConsoleLogger.js';
export * from './MemoryLogger.js';
export * from './ApplicationInsights.js';
export * from './LoggerService.js';
export * from './styles.js';
export * from './qbo-logging.js';
export * from './qbo-find.js';
export * from './qbo-jsontable.js';
export * from './qbo-logreader.js';
export function enumValue(enumObj, value) {
    const keys = Object.keys(enumObj).filter(x => isNaN(Number(x))); // Get enum keys
    const foundKey = keys.find(key => key.toLowerCase() === value.toLowerCase());
    return foundKey !== undefined ? enumObj[foundKey] : undefined;
}
export function trace(message, ...args) {
    window.dispatchEvent(new CustomEvent(RESOURCES.WRITE_LOG, { detail: { logLevel: LogLevel.Trace, message: message, ...args } }));
    console.log(message, ...args);
}
export function debug(message, ...args) {
    window.dispatchEvent(new CustomEvent(RESOURCES.WRITE_LOG, { detail: { logLevel: LogLevel.Debug, message: message, ...args } }));
}
export function info(message, ...args) {
    window.dispatchEvent(new CustomEvent(RESOURCES.WRITE_LOG, { detail: { logLevel: LogLevel.Information, message: message, ...args } }));
}
export function warn(message, ...args) {
    window.dispatchEvent(new CustomEvent(RESOURCES.WRITE_LOG, { detail: { logLevel: LogLevel.Warning, message: message, ...args } }));
}
export function error(message, ...args) {
    window.dispatchEvent(new CustomEvent(RESOURCES.WRITE_LOG, { detail: { logLevel: LogLevel.Error, message: message, ...args } }));
}
export function critial(message, error, ...args) {
    window.dispatchEvent(new CustomEvent(RESOURCES.WRITE_LOG, { detail: { logLevel: LogLevel.Critical, message: message, error: error, ...args } }));
}
// export { enumValue }
//# sourceMappingURL=Program.js.map